import React from 'react';
import { styled } from '@mui/material';
import {
  AccountBalanceWalletOutlined,
  FilterAltOutlined,
  MasksOutlined,
  TrendingUpOutlined,
} from '@mui/icons-material';
import ReportMetricCard from 'components/report/ReportMetricCard';
import { moneyFormat } from 'helpers/moneyFormat';
import { useReportGuide } from './hooks/useReportGuide';

const Container = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gap: theme.spacing(1.5),
  alignItems: 'stretch',
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

const ReportGuideTotal: React.FC = () => {
  const { summary, guides } = useReportGuide();
  // Sem resumo da API (back-end antigo), usa só as guias da página carregada.
  const counted = summary
    ? [summary.by_status.completed]
    : guides
        .filter(guide => guide.status === 'completed')
        .map(guide => ({ count: 1, value_total: guide.value_total, value_discount: guide.value_discount }));
  const totalValue = counted.reduce((acc, item) => acc + (item?.value_total ?? 0), 0);
  const totalDiscount = counted.reduce((acc, item) => acc + (item?.value_discount ?? 0), 0);
  const totalConsultations = counted.reduce((acc, item) => acc + (item?.count ?? 0), 0);
  const averageValue = totalConsultations > 0 ? totalValue / totalConsultations : 0;
  const discountPercent = totalValue > 0 ? (totalDiscount / (totalValue + totalDiscount)) * 100 : 0;

  return (
    <Container>
      <ReportMetricCard
        icon={<AccountBalanceWalletOutlined />}
        label="Faturamento total"
        value={moneyFormat(totalValue)}
        helper={`${totalConsultations} consultas consideradas`}
        tone="primary"
      />
      <ReportMetricCard
        icon={<TrendingUpOutlined />}
        label="Ticket médio"
        value={moneyFormat(averageValue)}
        helper="Valor médio por consulta no filtro atual"
        tone="success"
      />
      <ReportMetricCard
        icon={<FilterAltOutlined />}
        label="Descontos"
        value={moneyFormat(totalDiscount)}
        helper={`${discountPercent.toFixed(1)}% do valor bruto estimado`}
        tone="warning"
      />
      <ReportMetricCard
        icon={<MasksOutlined />}
        label="Volume"
        value={totalConsultations}
        helper="Consultas concluídas no período"
        tone="info"
      />
    </Container>
  );
};

export default ReportGuideTotal;
